import { RouteItem } from '../../../../../pages/admin-dashboard/admin-route-management/routes.model';
import { RouteTableRow } from './route-table.model';

function toRouteTableRow(route: RouteItem, index: number, isArabic: boolean): RouteTableRow {
  return {
    id: route.id,
    index: index + 1,
    routeName: route.name,
    cityGovernorate: '',
    regionsCount: route.regionsCount,
    pharmaciesCount: route.pharmaciesNumber,
    createdOn: route.createdOn,
    createdBy: route.createdBy?.fullName ?? '—',
    lastModifiedOn: route.lastModifiedOn ?? null,
    lastModifiedBy: route.lastModifiedBy?.fullName ?? null,
    status: {
      titleEn: route.isActive ? 'Active' : 'Inactive',
      titleAr: route.isActive ? 'مفعّل' : 'غير مفعّل',
    },
  };
}

export function toRouteTableRows(routes: RouteItem[], isArabic: boolean): RouteTableRow[] {
  return routes.map((r, i) => toRouteTableRow(r, i, isArabic));
}
